import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import propTypes from 'prop-types';

import { COLOR_1, COLOR_2, COLOR_4 } from '../../../styled/variables/variables';
import { backgrounder, mqTablet } from '../../../styled/helpers/helpers';
import { BaseLabel } from '../../../styled/labels/labels';
import { ProfilePicture } from '../../../styled/components/components';
import { BaseButton } from '../../../styled/buttons/buttons';

import RatingStars from '../../../components/rating-stars';

import pathConstants from '../../../constants/paths';
import queryStringUtil from '../../../utils/query-string/query-string.util';

/*
  global
  process
*/

const { PUBLIC_URL } = process.env;

const Cover = ({
  name,
  pictureUrl,
  rating,
  id,
  history,
}) => (
  <Wrapper>
    <ContentWrapper>
    </ContentWrapper>
  </Wrapper>
);

Cover.propTypes = {
  id: propTypes.string.isRequired,
  name: propTypes.string,
  pictureUrl: propTypes.string,
  rating: propTypes.number,
  history: propTypes.object,
};

const Wrapper = styled.div`
  background-color: ${ COLOR_1 };
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  padding-top: 120px;
  margin-bottom: 170px;

  * { position: relative; }
  &:before {
    content: "";
    ${ backgrounder(`${ PUBLIC_URL }/imgs/koort-texture-outline.svg`) };
    background-size: 800px;
    height: 100%;
    width: 100%;
    opacity: .3;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }

  ${ mqTablet`
    margin-bottom: 90px;

    &:before {
      background-size: 600px;
      background-repeat: repeat;
    }
  ` }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${ mqTablet`
    flex-direction: row;
    width: 100%;
    max-width: 1000px;
    align-self: center;
    margin-top: 40px;
    padding: 0 10px;
  ` }
`;

export default withRouter(Cover);
